<template>
    <div>
        <button
            class="w-full flex justify-between items-center mb-2"
            @click="isCollapsed = !isCollapsed"
        >
            <span class="font-heading text-lg underline underline-offset-4 decoration-1">
                {{ title }}
            </span>
            <div class="flex items-center gap-2">
                <span
                    v-if="filterCount > 0"
                    class="filter-count-badge"
                >
                    {{ filterCount }}
                </span>
                <ChevronDownIcon
                    v-if="isCollapsed"
                    class="w-4 h-4"
                />
                <ChevronUpIcon
                    v-else
                    class="w-4 h-4"
                />
            </div>
        </button>
        <transition
            name="collapse"
            @before-enter="beforeEnter"
            @enter="enter"
            @after-enter="afterEnter"
            @before-leave="beforeLeave"
            @leave="leave"
            @after-leave="afterLeave"
        >
            <div
                v-if="!isCollapsed"
                ref="content"
                class="collapse-content"
            >
                <slot />
            </div>
        </transition>
    </div>
</template>

<script>
import ChevronDownIcon from '~/static/fonts/LineIcons/chevron-down.svg';
import ChevronUpIcon from '~/static/fonts/LineIcons/chevron-up.svg';

export default {
    name: 'CategoryFilterCollapse',

    components: {
        ChevronDownIcon,
        ChevronUpIcon,
    },

    props: {
        title: {
            type: String,
            required: true,
        },
        filterCount: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            isCollapsed: true,
        };
    },

    methods: {
        beforeEnter(element) {
            if (!process.client) return;
            element.style.height = '0';
        },

        enter(element) {
            if (!process.client) return;
            element.style.height = `${element.scrollHeight}px`;
        },

        afterEnter(element) {
            if (!process.client) return;
            element.style.height = 'auto';
        },

        beforeLeave(element) {
            if (!process.client) return;
            const { height } = window.getComputedStyle(element);
            element.style.height = height;
        },

        leave(element, done) {
            if (!process.client) {
                done();
                return;
            }

            // Use Vue's nextTick to ensure the previous height was applied
            this.$nextTick(() => {
                element.style.height = '0';
                // Wait for the transition to complete before calling done
                setTimeout(done, 300);
            });
        },

        afterLeave(element) {
            if (!process.client) return;
            element.style.height = '';
        },
    },
};
</script>

<style scoped>
.collapse-content {
    overflow: hidden;
    transition: height 0.3s ease-out;
}

.filter-count-badge {
    @apply flex items-center justify-center text-sm text-primary font-bold;
}
</style>
